import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { UserPermissions } from '@shared-libs/enums';
import { UserManager } from '@app/modules/shared/managers/user.manager';
import { FormGroupDirective } from '@angular/forms';

@Directive({
	selector: '[disable-form-if-not-permission]',
})
export class DisableFormIfNotPermissionDirective implements OnInit {
	@Input() public 'disable-form-if-not-permission': Array<UserPermissions>;

	constructor(
		private readonly formGroupDirective: FormGroupDirective,
		private readonly userManager: UserManager,
		private readonly renderer: Renderer2,
		private readonly hostElement: ElementRef
	) {}

	public ngOnInit(): void {
		this.userManager.getUserPermissionsSubject().subscribe(() => {
			this.checkPermissions(this['disable-form-if-not-permission']);
		});
	}

	private checkPermissions(requiredPermissions: Array<UserPermissions>): void {
		const formGroup = this.formGroupDirective.form;
		if (formGroup) {
			if (this.userManager.hasAllPermissions(requiredPermissions)) {
				formGroup.enable();
			} else {
				formGroup.disable();
				this.renderer.addClass(this.hostElement.nativeElement, '_directive-disabled-form');
			}
		}
	}
}
